import { useTreeViewItems } from '../internals/plugins/useTreeViewItems';
import { useTreeViewExpansion } from '../internals/plugins/useTreeViewExpansion';
import { useTreeViewSelection } from '../internals/plugins/useTreeViewSelection';
import { useTreeViewFocus } from '../internals/plugins/useTreeViewFocus';
import { useTreeViewKeyboardNavigation } from '../internals/plugins/useTreeViewKeyboardNavigation';
import { useTreeViewIcons } from '../internals/plugins/useTreeViewIcons';
import { useTreeViewJSXItems } from '../internals/plugins/useTreeViewJSXItems';
export const SIMPLE_TREE_VIEW_PLUGINS = [useTreeViewItems, useTreeViewExpansion, useTreeViewSelection, useTreeViewFocus, useTreeViewKeyboardNavigation, useTreeViewIcons, useTreeViewJSXItems];

// We can't infer this type from the plugin, otherwise we would lose the generics.